export const getKwFromPlug = (plug?: powerready.incentives.IProjectSizePlug): number => {
    if (!plug?.amount_kw || !plug?.count) {
        return 0;
    } else {
        return Number(plug.count) * Number(plug.amount_kw);
    }
};
